// Add your custom JS here.
/* global document, window */

jQuery( document ).ready( function( $ ) {
	// Toggle navbar transparency.
	$( window ).scroll( function() {
		$( 'body.page-template-fullwidthpage nav.transparent-navbar' ).toggleClass( 'navbar-dark bg-transparent', $( this ).scrollTop() < 50 );
		$( 'body.page-template-fullwidthpage nav.transparent-navbar' ).toggleClass( 'navbar-light bg-light shadow-sm', $( this ).scrollTop() >= 50 );
	} );

	// Toggle selected subscription plan.
	$( '.subscribe-service-form .card' ).on( 'click', function() {
		$( '.subscribe-service-form .card.selected' ).removeClass( 'selected' );
		$( this ).addClass( 'selected' );
	} );
} );
